import * as React from "react";
import classnames from "classnames";
import { Heading } from "@grandvisionhq/elements";
import { connect, withIntl, statusFailed } from "@grandvisionhq/state";
import EmailForm from "../../../../components/EmailForm/components/EmailForm/EmailForm.js";
import EmailSentConfirmation from "../../../../components/EmailSentConfirmation/components/EmailSentConfirmation/EmailSentConfirmation.js";
import { logCreateAccountEvent } from "../../../../data-layer/data-layer/create-account.js";
import { getAuth } from "../../../../selectors.js";
import { isUninitialized } from "../../../../state.js";
/* empty css                        */
import { resetPassword } from "../../../ResetPassword/actions.js";
const elementName = "submit-email-address";
const SubmitEmailAddress = ({ auth, resetPassword: resetPassword2, intl }) => {
  const [state, setState] = React.useState({
    email: "",
    isEmailSubmitted: false
  });
  const onHandleResend = () => {
    logCreateAccountEvent({ type: "reset_password_resend_click" });
    setState({
      email: "",
      isEmailSubmitted: false
    });
  };
  const onSubmit = (email2) => {
    logCreateAccountEvent({ type: "reset_password_click" });
    setState({ email: email2, isEmailSubmitted: true });
    resetPassword2({ email: email2 });
  };
  const { email, isEmailSubmitted } = state;
  if (isUninitialized(auth)) {
    return null;
  }
  const error = statusFailed(auth.resetPasswordCall) ? new Error(intl.getLabel("account.resetPassword.updatePassword.errors.general")) : void 0;
  if (isEmailSubmitted) {
    return /* @__PURE__ */ React.createElement(
      EmailSentConfirmation,
      {
        onResend: onHandleResend,
        email,
        title: intl.getLabel("account.resetPassword.confirmation.title"),
        firstParagraph: intl.getLabel("account.resetPassword.confirmation.firstParagraph"),
        secondParagraph: intl.getLabel("account.resetPassword.confirmation.secondParagraph"),
        thirdParagraph: intl.getLabel("account.resetPassword.confirmation.thirdParagraph"),
        resendLink: intl.getLabel("account.action.resendLink"),
        successMessage: "account.resetPassword.success",
        error
      }
    );
  }
  return /* @__PURE__ */ React.createElement("div", { className: classnames(elementName, "myaccount__section") }, /* @__PURE__ */ React.createElement(Heading, { variant: "medium", component: "h1", className: `${elementName}__title` }, intl.getLabel("account.resetPassword.submitEmailAddress.title")), /* @__PURE__ */ React.createElement("p", { className: `${elementName}__text` }, intl.getLabel("account.resetPassword.submitEmailAddress.text")), /* @__PURE__ */ React.createElement(
    EmailForm,
    {
      buttonLabel: intl.getLabel("account.action.resetPassword"),
      "data-t": "reset-password-form",
      emailErrorLabel: intl.getLabel("account.error.emailInvalid"),
      emailLabel: intl.getLabel("fields.input.email.label"),
      onSubmit
    }
  ));
};
const mapStateToProps = (state) => ({
  auth: getAuth(state)
});
const mapDispatchToProps = {
  resetPassword
};
const SubmitEmailAddress$1 = connect(mapStateToProps, mapDispatchToProps)(withIntl(SubmitEmailAddress));
export {
  SubmitEmailAddress,
  SubmitEmailAddress$1 as default,
  mapDispatchToProps,
  mapStateToProps
};
//# sourceMappingURL=SubmitEmailAddress.js.map
